import {
  Button,
  Description,
  Drawer,
  Spinner,
  type OverlayTriggerState,
} from '@heroui/react';
import type { AvailabilityWindow, ParkingSpotOwner } from '../../../api/my-parking-spots';
import { drawerBodyClassName, drawerFooterClassName, sideDrawerDialogClassName } from '../../../components/ui/side-drawer-classes';
import { ActiveWindowsAgendaView } from './active-windows-agenda-view';

interface ActiveWindowsDrawerProps {
  state: OverlayTriggerState;
  spot: ParkingSpotOwner | null;
  windows: AvailabilityWindow[];
  loading: boolean;
  onEditWindow: (window: AvailabilityWindow) => void;
  onCancelWindow: (window: AvailabilityWindow) => void;
}

export function ActiveWindowsDrawer({
  state,
  spot,
  windows,
  loading,
  onEditWindow,
  onCancelWindow,
}: ActiveWindowsDrawerProps) {
  return (
    <Drawer state={state}>
      <Drawer.Backdrop isDismissable>
        <Drawer.Content placement="right">
          <Drawer.Dialog className={sideDrawerDialogClassName}>
            <Drawer.Header>
              <Drawer.Heading>
                {spot ? `Janelas ativas · ${spot.spotCode}` : 'Janelas ativas'}
              </Drawer.Heading>
              <Drawer.CloseTrigger />
            </Drawer.Header>

            <Drawer.Body className={drawerBodyClassName}>
              {spot ? (
                <Description>
                  Visualize as janelas no calendário e gerencie os períodos abertos para esta vaga.
                </Description>
              ) : null}

              {loading ? (
                <div className="flex justify-center py-8">
                  <Spinner />
                </div>
              ) : windows.length === 0 ? (
                <Description className="py-8 text-center">
                  Nenhuma janela de disponibilidade ativa no momento.
                </Description>
              ) : (
                <ActiveWindowsAgendaView
                  windows={windows}
                  onEditWindow={onEditWindow}
                  onCancelWindow={onCancelWindow}
                />
              )}
            </Drawer.Body>

            <Drawer.Footer className={`${drawerFooterClassName} !justify-stretch`}>
              <Button variant="secondary" className="w-full" onPress={() => state.close()}>
                Fechar
              </Button>
            </Drawer.Footer>
          </Drawer.Dialog>
        </Drawer.Content>
      </Drawer.Backdrop>
    </Drawer>
  );
}
